var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShow
    ? _c("div", { staticClass: "app-container-sitc" }, [
        _c("div", { staticClass: "container-content" }, [
          _c(
            "div",
            {
              staticClass: "half-width-scroll",
              staticStyle: { "padding-right": "5px" },
            },
            [
              _c("book-materials-detail", {
                attrs: {
                  differentKeys: _vm.differentKeys,
                  consignerCheck: _vm.consignerCheck,
                  consigneeCheck: _vm.consigneeCheck,
                  notifierOneCheck: _vm.notifierOneCheck,
                  notifierTwoCheck: _vm.notifierTwoCheck,
                  bkCargoDiff: _vm.bkCargoDiff,
                  bkPreContainerDiff: _vm.bkPreContainerDiff,
                  bkContainerDiff: _vm.bkContainerDiff,
                  feeItemDiff: _vm.feeItemDiff,
                  bkYardDiff: _vm.bkYardDiff,
                  bkDocumentDiff: _vm.bkDocumentDiff,
                  form: _vm.ebVerBookingHeadCom,
                  titleFlag: "2",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "half-width-scroll",
              staticStyle: { "padding-left": "5px" },
            },
            [
              _c("book-materials-detail", {
                attrs: {
                  differentKeys: _vm.differentKeys,
                  consignerCheck: _vm.consignerCheck,
                  consigneeCheck: _vm.consigneeCheck,
                  notifierOneCheck: _vm.notifierOneCheck,
                  notifierTwoCheck: _vm.notifierTwoCheck,
                  bkCargoDiff: _vm.bkCargoDiff,
                  bkPreContainerDiff: _vm.bkPreContainerDiff,
                  bkContainerDiff: _vm.bkContainerDiff,
                  feeItemDiff: _vm.feeItemDiff,
                  bkYardDiff: _vm.bkYardDiff,
                  bkDocumentDiff: _vm.bkDocumentDiff,
                  form: _vm.webBookingHeadCom,
                  titleFlag: "3",
                },
              }),
            ],
            1
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }